//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import appDownloadDialog from '../app-download-dialog/index.vue'

  import Langs from '../Lang/index.vue'
  export default {
    components: { Langs ,appDownloadDialog},
    data() {
      return {
        headOpen: false,
        showLogBtn: false // 是否展示登录按钮
      }
    },
    computed:{
      accountBalance() {
        return this.$store.state.userInfo.assetsInfoMap.accountBalance > 0 ? this.$store.state.userInfo.assetsInfoMap.accountBalance.toFixed(2) : '0.00'
      }
    },
    watch: {
      $route: {
        handler(v) {
          this.showLogBtn = false // 路由切换关闭登录注册按钮
          this.headOpen = false
        },
        deep: true
      }
    },
    methods: {
      dontDo() {
        return false
      },
      handleClick() {
        if (this.$store.state.isLogin) {
          this.$router.push({ path: '/My/Wallet' })
        } else {
          this.showLogBtn = !this.showLogBtn
        }
      }
    }
  }



// WEBPACK FOOTER //
// ./src/pages/build922/views/components/header/base.vue